import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAuthStore } from '#/hooks/useAuthStore';
import { Loading } from '#/layouts';
import { clearSelfServiceSession } from '#/lib/selfServiceSession';
import { useUser } from '@auth0/nextjs-auth0/client';

export const AgentLogout: React.FC<React.PropsWithChildren> = observer(function AgentLogoutComponent({ children }) {
    const { user } = useUser();
    const authStore = useAuthStore();

    const isLoading = authStore.isLoading || authStore.profileRefreshing;
    const profileReady = Boolean(!isLoading && authStore.isAuthenticated && authStore.profile);
    if (user?.isAgent && profileReady) {
        clearSelfServiceSession();
        const logoutParams = new URLSearchParams({
            returnTo: '/?error=agents_not_allowed',
        });
        window.location.href = new URL(`/logout?${logoutParams}`, window.location.origin).toString();
    }

    return user?.isAgent ? <Loading /> : children;
});
